import OverstockQuoteForm from "./OverstockQuoteForm";

const products = [
  {
    name: "Industrial LED Fixtures",
    category: "Lighting",
    discount: "30%",
    image: "https://public.readdy.ai/ai/img_res/8f7577406d9a814720ff57290599cb14.jpg",
  },
  {
    name: "Children's Electronics Bundle",
    category: "Kids Electronics",
    discount: "20%",
    image: "https://readdy.ai/api/search-image?query=colorful%20childrens%20educational%20electronics%20tablets%20learning%20devices%20kids%20gadgets%20toys%20clean%20white%20studio%20background%20product%20photography%20simple%20background&width=300&height=300&seq=overstock-002b&orientation=squarish",
  },
  {
    name: "Safety Work Gloves",
    category: "Safety Gear",
    discount: "35%",
    image: "https://readdy.ai/api/search-image?query=industrial%20safety%20work%20gloves%20orange%20yellow%20protective%20equipment%20clean%20white%20studio%20background%20product%20photography&width=300&height=300&seq=overstock-003&orientation=squarish",
  },
  {
    name: "Adult & Kids Clothing",
    category: "Apparel",
    discount: "40%",
    image: "https://readdy.ai/api/search-image?query=folded%20mixed%20adult%20and%20childrens%20clothing%20apparel%20stack%20casual%20wear%20t-shirts%20jeans%20clean%20minimal%20white%20background%20product%20photography%20studio&width=300&height=300&seq=overstock-004b&orientation=squarish",
  },
  {
    name: "Microfiber Cleaning Cloths",
    category: "Cleaning",
    discount: "30%",
    image: "https://readdy.ai/api/search-image?query=microfiber%20cleaning%20cloths%20colorful%20folded%20stack%20household%20cleaning%20supplies%20white%20background%20product%20photography&width=300&height=300&seq=overstock-005&orientation=squarish",
  },
  {
    name: "Foam Packaging Inserts",
    category: "Packaging",
    discount: "25%",
    image: "https://readdy.ai/api/search-image?query=protective%20foam%20packaging%20inserts%20industrial%20packing%20materials%20white%20clean%20background%20product%20photography%20studio&width=300&height=300&seq=overstock-006&orientation=squarish",
  },
];

export default function OverstockSection() {
  const handleInquiry = () => {
    const target = document.querySelector("#contact");
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="overstock" className="py-24 bg-[#222831]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-archive-drawer-line text-[#C9A227] text-sm"></i>
              </div>
              <span className="text-xs font-semibold uppercase tracking-widest text-[#C9A227]">
                Inventory Solutions · Pillar 03
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight">
              Your Inventory
              <br />
              <span className="text-[#C9A227]">Solutions Marketplace</span>
            </h2>
            <p className="mt-4 text-base text-white/60 max-w-lg leading-relaxed">
              Whether you're buying surplus at deep-discount prices or clearing excess
              stock fast — our Inventory Solutions pillar connects buyers and sellers
              across hundreds of categories through a transparent, five-step clearance process.
            </p>
            <button
              onClick={() => {
                const el = document.querySelector("#how-it-works");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold text-[#C9A227] hover:gap-2.5 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-right-circle-line text-sm"></i>
              See the 5-step Inventory Solutions process
            </button>
          </div>
          <button
            onClick={handleInquiry}
            className="px-7 py-3.5 rounded-full border-2 border-[#C9A227] text-[#C9A227] font-semibold text-sm hover:bg-[#C9A227] hover:text-white transition-all cursor-pointer whitespace-nowrap self-start lg:self-auto flex items-center gap-2"
          >
            Browse All Inventory <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {products.map((product) => (
            <div
              key={product.name}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
              onClick={handleInquiry}
            >
              {/* Image */}
              <div className="relative w-full h-56">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#222831]/85 via-transparent to-transparent"></div>
                {/* Discount Badge */}
                <div className="absolute top-3 right-3 w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A227] text-white text-xs font-extrabold">
                  -{product.discount}
                </div>
                {/* Category Badge */}
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-[#222831]/80 text-white text-xs font-semibold">
                  {product.category}
                </div>
              </div>

              {/* Info */}
              <div className="bg-[#3A506B] p-5">
                <h3 className="text-white font-bold text-base">{product.name}</h3>
                <button className="mt-4 w-full py-2.5 rounded-xl bg-white/10 hover:bg-[#C9A227] text-white text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  Quick Inquiry
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Custom Quote Form */}
        <OverstockQuoteForm />

        {/* Bottom Banner */}
        <div className="mt-12 rounded-2xl border border-white/10 bg-white/5 p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#C9A227]/20 flex-shrink-0">
              <i className="ri-archive-drawer-line text-2xl text-[#C9A227]"></i>
            </div>
            <div>
              <p className="text-white font-bold text-base">Have surplus inventory to liquidate?</p>
              <p className="text-white/50 text-sm mt-0.5">
                Submit your stock details and our Inventory Solutions team starts matching
                you with qualified bulk buyers — Step 1 of our 5-step clearance process.
              </p>
            </div>
          </div>
          <button
            onClick={handleInquiry}
            className="px-7 py-3 rounded-full bg-[#C9A227] text-white font-semibold text-sm hover:bg-[#b08f1e] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 flex-shrink-0"
          >
            Start Listing Your Inventory <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
